import script from "./UiToaster.vue?vue&type=script&setup=true&lang=js"
export * from "./UiToaster.vue?vue&type=script&setup=true&lang=js"

import "./UiToaster.vue?vue&type=style&index=0&id=2ee20291&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ee20291"]])

export default __exports__